export default __webpack_public_path__ + "media/zurb/img/development-process/javascript-c14585574561a752e966a747495c7b86.png";